<template>
  <div class="rating-body">
    <CardList
      class="-margin-m-"
      :card-list="cardList"
      :loading="isGroupLoading"
    />
    <TeamTable :nav-titles="navTitles" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import numberFormat from '@/filters/numberFormat.filter';

import TeamTable from '../TeamTable';
import CardList from '@/views/Rating/components/CardList';

export default {
  components: {
    TeamTable,
    CardList
  },
  data: () => ({
    selectedTab: 0,
    tabList: [
      {
        id: 0,
        title: 'Отображение по командам'
      }
    ],
    navTitles: [
      {
        title: 'Имя',
        id: 1,
        width: '2fr'
      },
      {
        title: 'Факультет / Сборная',
        id: 3,
        width: '1fr'
      },
      {
        title: 'Ниша',
        id: 2,
        width: '1fr'
      },
      {
        title: 'Выручка',
        id: 4,
        width: '1fr'
      },
      {
        title: 'Прибыль',
        id: 5,
        width: '1fr'
      }
    ]
  }),
  computed: {
    ...mapState('ratingTeams', {
      isGroupLoading: s => s.meta.isGroupLoading,
      tractionSummary: s => s.data.tractionSummary,
      selectWeek: s => s.data.filterList.week
    }),
    ...mapGetters('ratingTeams', {
      teamList: 'teamList'
    }),
    activeComponent() {
      switch (this.selectedTab) {
        case 0:
          return 'TeamTable';
        default:
          return 'HundredTable';
      }
    },
    cardList() {
      return [
        {
          icon: 'round-icon-proceeds',
          title: `${numberFormat(this.tractionSummary.revenue) || 0} ₽`,
          description:
            this.selectWeek !== '-1' ? 'Выручка за курс' : 'Выручка до курса'
        },
        {
          icon: 'round-icon-discount',
          title: `${numberFormat(this.tractionSummary.profit) || 0} ₽`,
          description:
            this.selectWeek !== '-1' ? 'Прибыль за курс' : 'Прибыль до курса'
        },
        {
          icon: 'round-icon-user',
          title: `${numberFormat(this.teamList.length) || 0}`,
          description: 'Команд'
        }
      ];
    }
  }
};
</script>
